<template>
  <div class="index" ref="fullPage" :class="isActive">
    <div class="index-page1" ref="firstPage" v-if="bookList.length != 0">
      <div class="index-pisition">
        <div class="search">
          <!-- <div class="search-logo">
            <el-image :src="require('../../assets/image/index/index_logo.png')" fit="fill" ></el-image>
          </div> -->
          <div class="index-search-inner" ref="selects">
            <el-input class="index-search-item" placeholder="请输入关键词" v-model="searchValue">
              <el-select :popper-append-to-body="true" placeholder="请选择" slot="prepend" v-model="searchS">
                <el-option :key="9999" label="全部" value="全部"></el-option>
                <el-option :key="item.index" :label="item.caption" :value="item.englishName" v-for="(item, index) in selectList"></el-option>
              </el-select>
              <el-button @click="setClickBus()" slot="append">
                <div class="button-title">
                  <el-image :lazy="true" :src="require('../../assets/image/index/jiansuo.png')" fit="fill"></el-image>
                  <div>
                    检索
                  </div>
                </div>
              </el-button>
            </el-input>
          </div>
        </div>
        <!-- <div class="booklist" v-if="bookList.length>0"> -->
        <indexPage :book-list="bookList"></indexPage>
        <!-- 页面共显示十本书籍  当数据不满足 则 从上往下 隐藏 -->
        <!-- <div class="book fast-1">
          <div v-if="bookList.length>10" class="book-show">
            <div class="book-image" >
              <el-image :src="bookList[9].pic == '/' ? require('../../assets/image/index/book.png') : bookList[9].pic" fit="fill" ></el-image>
              <div class="image-tile" :class="bookList[9].pic != '/' ? 'show' : ''">
                <div class="image-boder">
                  {{bookList[9].title}}
                </div>
              </div>
            </div>
            <div class="fast-1-title">《{{bookList[9].title}}》</div>
            <div class="fast-box">
              <div class="fast-box-title">《{{bookList[9].title}}》</div>
              <div class="fast-box-xiangq" @click="$router.push({path:'/resource/detail',query:{bookId:bookList[9].bookId}})">查看书籍>></div>
            </div>
          </div>
        </div>
        <div class="book fast-2" >
          <div v-if="bookList.length>8" class="book-show">
            <div class="book-image" >
              <el-image :src="bookList[8].pic == '/' ? require('../../assets/image/index/book.png') : bookList[8].pic" fit="fill" ></el-image>
              <div class="image-tile" :class="bookList[8].pic != '/' ? 'show' : ''">
                <div class="image-boder">
                  {{bookList[8].title}}
                </div>
              </div>
            </div>
            <div class="fast-1-title">《{{bookList[8].title}}》</div>
            <div class="fast-box">
              <div class="fast-box-title">《{{bookList[8].title}}》</div>
              <div class="fast-box-xiangq" @click="$router.push({path:'/resource/detail',query:{bookId:bookList[8].bookId}})">查看书籍>></div>
            </div>
          </div>
        </div>
        <div class="book fast-3" >
          <div v-if="bookList.length>7" class="book-show">
            <div class="book-image" >
              <el-image :src="bookList[7].pic == '/' ? require('../../assets/image/index/book.png') : bookList[7].pic" fit="fill" ></el-image>
              <div class="image-tile" :class="bookList[7].pic != '/' ? 'show' : ''">
                <div class="image-boder">
                  {{bookList[7].title}}
                </div>
              </div>
            </div>
            <div class="fast-1-title">《{{bookList[7].title}}》</div>
            <div class="fast-box">
              <div class="fast-box-title">《{{bookList[7].title}}》</div>
              <div class="fast-box-xiangq" @click="$router.push({path:'/resource/detail',query:{bookId:bookList[7].bookId}})">查看书籍>></div>
            </div>
          </div>
        </div>
        <div class="book fast-4" >
          <div v-if="(bookList.length>6)" class="book-show">
            <div class="book-image" >
              <el-image :src="bookList[6].pic == '/' ? require('../../assets/image/index/book.png') : bookList[6].pic" fit="fill" ></el-image>
              <div class="image-tile" :class="bookList[6].pic != '/' ? 'show' : ''">
                <div class="image-boder">
                  {{bookList[6].title}}
                </div>
              </div>
            </div>
            <div class="fast-1-title">《{{bookList[6].title}}》</div>
            <div class="fast-box">
              <div class="fast-box-title">《{{bookList[6].title}}》</div>
              <div class="fast-box-xiangq" @click="$router.push({path:'/resource/detail',query:{bookId:bookList[6].bookId}})">查看书籍>></div>
            </div>
          </div>
        </div>
        <div class="book fast-5" >
          <div v-if="(bookList.length>5)" class="book-show">
            <div class="book-image" >
              <el-image :src="bookList[5].pic == '/' ? require('../../assets/image/index/book.png') : bookList[5].pic" fit="fill" ></el-image>
              <div class="image-tile" :class="bookList[5].pic != '/' ? 'show' : ''">
                <div class="image-boder">
                  {{bookList[5].title}}
                </div>
              </div>
            </div>
            <div class="fast-1-title">《{{bookList[5].title}}》</div>
            <div class="fast-box">
              <div class="fast-box-title">《{{bookList[5].title}}》</div>
              <div class="fast-box-xiangq" @click="$router.push({path:'/resource/detail',query:{bookId:bookList[5].bookId}})">查看书籍>></div>
            </div>
          </div>
        </div>
        <div class="book fast-6" >
          <div v-if="(bookList.length>4)" class="book-show">
            <div class="book-image" >
              <el-image :src="bookList[4].pic == '/' ? require('../../assets/image/index/book.png') : bookList[4].pic" fit="fill" ></el-image>
              <div class="image-tile" :class="bookList[4].pic != '/' ? 'show' : ''">
                <div class="image-boder">
                  {{bookList[4].title}}
                </div>
              </div>
            </div>
            <div class="fast-1-title">《{{bookList[4].title}}》</div>
            <div class="fast-box">
              <div class="fast-box-title">《{{bookList[4].title}}》</div>
              <div class="fast-box-xiangq" @click="$router.push({path:'/resource/detail',query:{bookId:bookList[4].bookId}})">查看书籍>></div>
            </div>
          </div>
        </div>
        <div class="book fast-7" >
          <div v-if="(bookList.length>3)" class="book-show">
            <div class="book-image" >
              <el-image :src="bookList[3].pic == '/' ? require('../../assets/image/index/book.png') : bookList[3].pic" fit="fill" ></el-image>
              <div class="image-tile" :class="bookList[3].pic != '/' ? 'show' : ''">
                <div class="image-boder">
                  {{bookList[3].title}}
                </div>
              </div>
            </div>
            <div class="fast-1-title">《{{bookList[3].title}}》</div>
            <div class="fast-box">
              <div class="fast-box-title">《{{bookList[3].title}}》</div>
              <div class="fast-box-xiangq" @click="$router.push({path:'/resource/detail',query:{bookId:bookList[3].bookId}})">查看书籍>></div>
            </div>
          </div>
        </div>
        <div class="book fast-8" >
          <div v-if="(bookList.length>2)" class="book-show">
            <div class="book-image" >
              <el-image :src="bookList[2].pic == '/' ? require('../../assets/image/index/book.png') : bookList[2].pic" fit="fill" ></el-image>
              <div class="image-tile" :class="bookList[2].pic != '/' ? 'show' : ''">
                <div class="image-boder">
                  {{bookList[2].title}}
                </div>
              </div>
            </div>
            <div class="fast-1-title">《{{bookList[2].title}}》</div>
            <div class="fast-box">
              <div class="fast-box-title">《{{bookList[2].title}}》</div>
              <div class="fast-box-xiangq" @click="$router.push({path:'/resource/detail',query:{bookId:bookList[2].bookId}})">查看书籍>></div>
            </div>
          </div>
        </div>
        <div class="book fast-9" >
          <div v-if="(bookList.length>1)" class="book-show">
            <div class="book-image" >
              <el-image :src="bookList[1].pic == '/' ? require('../../assets/image/index/book.png') : bookList[1].pic" fit="fill" ></el-image>
              <div class="image-tile" :class="bookList[1].pic != '/' ? 'show' : ''">
                <div class="image-boder">
                  {{bookList[1].title}}
                </div>
              </div>
            </div>
            <div class="fast-1-title">《{{bookList[1].title}}》</div>
            <div class="fast-box">
              <div class="fast-box-title">《{{bookList[1].title}}》</div>
              <div class="fast-box-xiangq" @click="$router.push({path:'/resource/detail',query:{bookId:bookList[1].bookId}})">查看书籍>></div>
            </div>
          </div>
        </div>
        <div class="book fast-10">
          <div v-if="(bookList.length>0)" class="book-show">
            <div class="book-image" >
              <el-image :src="bookList[0].pic == '/' ? require('../../assets/image/index/book.png') : bookList[0].pic" fit="fill" ></el-image>
              <div class="image-tile" :class="bookList[0].pic != '/' ? 'show' : ''">
                <div class="image-boder">
                  {{bookList[0].title}}
                </div>
              </div>
            </div>
            <div class="fast-1-title">《{{bookList[0].title}}》</div>
            <div class="fast-box">
              <div class="fast-box-title">《{{bookList[0].title}}》</div>
              <div class="fast-box-xiangq" @click="$router.push({path:'/resource/detail',query:{bookId:bookList[0].bookId}})">查看书籍>></div>
            </div>
          </div>
        </div> -->
        <!-- </div> -->
        <div @click="$router.push({path:'/resource/inbook',query:{ref:'ref99999'}})" class="more">
          查看更多
        </div>
      </div>
    </div>
    <div class="index-page2" v-if="dataList.videoList.length!=0">
      <div class="index-pisitions">
        <div class="speciabox">
          <div class="special"></div>
        </div>
        <!-- <div class="special-box">
          <div class="special-box-item morans" @click="$router.push({path:'/resource/inbook',query:{ref:'zhulao'}})">
            <div class="moran">
              查看更多<el-image :src="require('../../assets/image/index/lefts.png')" fit="fill"></el-image>
            </div>
          </div>
          <div class="special-box-item1 morans" @click="$router.push({path:'/resource/inbook',query:{ref:'zhonghua'}})">
            <div class="moran">
              查看更多<el-image :src="require('../../assets/image/index/lefts.png')" fit="fill"></el-image>
            </div>
          </div>
          <div class="special-box-item2 morans" @click="$router.push({path:'/resource/inbook',query:{ref:'guangxidi'}})">
            <div class="moran">
              查看更多<el-image :src="require('../../assets/image/index/lefts.png')" fit="fill"></el-image>
            </div>
          </div>
        </div>
        <div class="special-box1">
          <div class="special-box-item3 morans" style="margin-right:4.375rem" @click="$router.push({path:'/resource/inbook',query:{ref:'guangxijing'}})">
            <div class="moran">
              查看更多<el-image :src="require('../../assets/image/index/lefts.png')" fit="fill"></el-image>
            </div>
          </div>
          <div class="special-box-item4 morans" @click="$router.push({path:'/resource/inbook',query:{ref:'guzhuangzi'}})">
            <div class="moran">
              查看更多<el-image :src="require('../../assets/image/index/lefts.png')" fit="fill"></el-image>
            </div>
          </div>
        </div> -->
        <!-- <div class="more">
          查看更多
        </div> -->
        <div class="special2-box">
          <div :key="index" @click="$router.push({path:'/resource/videoshows',query:{bookId:item.bookId}})" class="special2-for" v-for="(item, index) in dataList.videoList">
            <el-image :src="item.pic=='/'?require('../../assets/image/index/video_image.png'):item.pic" fit="cover"></el-image>
            <div class="banner-title">{{item.title}}</div>
          </div>
        </div>
        <div class="more-center">
          <div @click="$router.push({path:'/resource/video',query:{ref:'ref99999'}})" class="more" style="cursor: pointer;">
            查看更多
          </div>
        </div>
      </div>
    </div>
    <div class="index-page3" v-if=" dataList.booksList.length!=0">
      <div class="index-pisition3">
        <div class="speciabox">
          <div class="special"></div>
        </div>
        <div class="swich">
          <div @click="imageLeft" class="swich-left">
            <el-image :src="require('../../assets/image/index/swich_left.png')" fit="fill"></el-image>
          </div>
          <div class="index-swich-posi" ref="posi">
            <div class="swich-banners" ref="swichs">
              <!-- dataList.bookList -->
              <div :key="index" @click="$router.push({path:'/resource/detail',query:{bookId:item.bookId}})" class="banner-item" v-for="(item, index) in dataList.booksList">
                <el-image :src="item.pic=='/'?require('../../assets/image/index/swich_banner.png'):item.pic" fit="fill"></el-image>
                <div class="banner-title">{{item.title}}</div>
                <!-- <div class="banner-yizu">影印译注</div> -->
              </div>
            </div>
          </div>

          <div @click="imageRight" class="swich-right">
            <el-image :src="require('../../assets/image/index/swich_right.png')" fit="fill"></el-image>
          </div>
        </div>
        <div class="more-center">
          <div @click="$router.push({path:'/resource/author',query:{ref:'ref99999'}})" class="more" style="cursor: pointer;">
            查看更多
          </div>
        </div>
        <!-- <div class="speciabox">
          <div class="special2"></div>
        </div> -->
        <!-- <div class="swich">
          <div class="swich-left" @click="videoLeft">
            <el-image :src="require('../../assets/image/index/swich_left.png')" fit="fill" ></el-image>
          </div>
          <div class="index-swich-posi swich-video" ref="videoposi">
            <div class="swich-banners" ref="videoswichs">
              <div v-for="(item, index) in dataList.videoList" :key="index" class="banner-item">
                <el-image :src="item.pic=='/'?require('../../assets/image/index/video_image.png'):item.pic" fit="fill" ></el-image>
              </div>
            </div>
          </div>
          <div class="swich-right" @click="videoRight">
            <el-image :src="require('../../assets/image/index/swich_right.png')" fit="fill" ></el-image>
          </div>
        </div>
        <div class="more-center">
          <div class="more" style="cursor: pointer;" @click="$router.push({path:'/resource/video'})">
            查看更多
          </div>
        </div> -->
      </div>
    </div>
    <div class="index-page4" v-if="dataList.imagesList.length!=0 || dataList.audioList.length!=0">
      <div class="index-pisition3">
        <div class="speciabox" v-show="dataList.imagesList.length!=0">
          <div class="special"></div>
        </div>
        <div class="swich" v-show="dataList.imagesList.length!=0">
          <div @click="timageLeft" class="swich-left">
            <el-image :src="require('../../assets/image/index/swich_left.png')" fit="fill"></el-image>
          </div>
          <div class="index-swich-posi" ref="tposi">
            <div class="swich-banners" ref="tswichs">
              <div :key="index" class="banner-item" v-for="(item, index) in dataList.imagesList">
                <el-image :preview-src-list="srcList" :src="item.pic=='/'?require('../../assets/image/index/imagesbg.png'):item.pic" fit="fill"></el-image>
                <div class="banner-title">{{item.title}}</div>
              </div>
            </div>
          </div>
          <div @click="timageRight" class="swich-right">
            <el-image :src="require('../../assets/image/index/swich_right.png')" fit="fill"></el-image>
          </div>
        </div>
        <div class="more-center" v-show="dataList.imagesList.length!=0">
          <div @click="$router.push({path:'/resource/image',query:{ref:'ref99999'}})" class="more" style="cursor: pointer;">
            查看更多
          </div>
        </div>
        <div class="speciabox" v-show="dataList.audioList.length!=0">
          <div class="special2"></div>
        </div>
        <div class="swich" v-show="dataList.audioList.length!=0">
          <div @click="audioLeft" class="swich-left">
            <el-image :src="require('../../assets/image/index/swich_left.png')" fit="fill"></el-image>
          </div>
          <div class="index-swich-posi swich-video" ref="audioposi">
            <div class="swich-banners" ref="audioswichs">
              <div :key="index" @click="$router.push({path:'/resource/detailsAud',query:{bookId:item.bookId}})" class="banner-item" v-for="(item, index) in dataList.audioList">
                <!-- <el-image :src="require('../../assets/image/index/audiobg.png')" fit="fill" ></el-image> -->
                <el-image :src="item.pic == '/'?require('../../assets/image/index/audiobg.png'):item.pic" fit="fill"></el-image>
                <div class="banner-title">{{item.title}}</div>
              </div>
            </div>
          </div>
          <div @click="audioRight" class="swich-right">
            <el-image :src="require('../../assets/image/index/swich_right.png')" fit="fill"></el-image>
          </div>
        </div>
        <div class="more-center" v-show="dataList.audioList.length!=0">
          <div @click="$router.push({path:'/resource/audio',query:{ref:'ref99999'}})" class="more" style="cursor: pointer;">
            查看更多
          </div>
        </div>
      </div>
    </div>
    <div class="index-footer" ref="indexFooter">
      <Footer class="footer"></Footer>
    </div>
  </div>
</template>

<script>
  import {listHomePageRecommend, listRecommendColumn} from "../../api/index"
  import {listSearchParam} from "../../api/resource"
  import Footer from "../../components/common/Footer.vue";
  import indexPage from "./indexPage.vue";

  export default {
    name: 'PortalIndex',
    components: {
      Footer, indexPage
    },
    data() {
      return {
        timeout: false,
        fullIndex: 0,
        searchValue: '',
        searchS: '全部',
        selectList: [
          // {
          //   englishName:'全部',
          //   url:'/resource/all',
          //   index:1
          // },
          // {
          //   englishName:'古籍底本',
          //   url:'/resource/inbook',
          //   index:2
          // },
          // {
          //   englishName:'精品图书',
          //   url:'/resource/author',
          //   index:3
          // },
          // {
          //   englishName:'民俗视频',
          //   url:'/resource/video',
          //   index:4
          // },
          // {
          //   englishName:'民俗图片',
          //   url:'/resource/image',
          //   index:5
          // },
          // {
          //   englishName:'民俗音频',
          //   url:'/resource/audio',
          //   index:1
          // },
        ],
        // 古籍底本
        bookList: [],
        /**
         * 存储推荐数据
         * Ancient 古籍底本
         * imagesList 民俗图片
         * booksList 精品图书
         * videoList 民俗视频
         * audioList 民俗音频
         */
        dataList: {
          Ancient: [],
          imagesList: [],
          booksList: [],
          videoList: [],
          audioList: []
        },
        // 精品图书
        index: 0,
        childLendth: 0,
        timeout: false,
        // 民宿视频
        vindex: 0,
        vchildLendth: 0,
        vtimeout: false,
        // 民俗图片
        tindex: 0,
        tchildLendth: 0,
        ttimeout: false,
        // 民俗音频
        aindex: 0,
        achildLendth: 0,
        atimeout: false,
        throttleLoad: null,
        srcList: [],
        isActive:'ref9999'
      };
    },
    mounted() {
      this.getSearchParams()
      // this.getData()
      let swich = this.$refs.fullPage
      let that = this
      swich.addEventListener("transitionend", () => {
        that.timeout = false
      }, true)
      this.throttleLoad = this.debounce(this.handleScroll, 300) || window.addEventListener("DOMMouseScroll", this.debounce(this.handleScroll, 300), true)
      // window.addEventListener('mousewheel', this.debounce(this.handleScroll,300), true) || window.addEventListener("DOMMouseScroll",this.debounce(this.handleScroll,300),true)
      this.$refs.fullPage.addEventListener('mousewheel', this.throttleLoad)
      // console.log(this.$refs.selects);
      if(!this.$refs.selects) return
      this.$refs.selects.addEventListener('mousewheel', () => {
      }, false)
    },
    beforeDestroy() {
      this.$refs.fullPage.removeEventListener('mousewheel', this.throttleLoad)
    },
    methods: {
      // 检索条件
      getSearchParams() {
        listSearchParam({
          typeId: this.$store.state.typeId
        }).then(res => {
          if (res && res.data.data) {
            res = res.data.data
            let searchList = []
            //去掉不显示的高级检索值
            res.map(data => {
              // const arr = ['ID', '审核状态', '主从', '元數據模版', 'OAI公开状态', 'OCR识别状态','全文信息','出入库状态','子分类','分类']
              const arr = ['是否公開', '元數據模版', "元数据模板", '分類', 'ID', '主从', '审核状态', 'OAI公开状态', 'OCR识别状态', '子分類', '冊數', '图片名列表'
            ,'图片路径','全文信息','分类','子分类','馆藏地址','基础价格','子库','中图分类号','书号','出版发行','原定书价','时长'

            ]
              const num = arr.findIndex(e => e == data.name)
              if (num < 0) {
                searchList.push(data)
              }
              return data
            })
            this.selectList = JSON.parse(JSON.stringify(searchList))
          }
        })
      },
      debounce(func, wait) {
        let timeouts;
        return function () {
          let context = this;
          let args = arguments;
          if (timeouts) clearTimeout(timeouts);
          if (this.timeout) return
          timeouts = setTimeout(() => {
            func.apply(context, args)
          }, wait);
        }
      },
      //判断滚动方向
      handleScroll(e) {
        let direction = e.deltaY > 0 ? 'down' : 'up'
        if (e.deltaY < 0) {
          this.scrollup()
        } else {
          this.scrolldown()
        }
      },
      // 向上 滚动 切换
      scrollup() {
        let fullPages = this.$refs.fullPage
        let indexFooter = this.$refs.indexFooter
        const FULL_PAGE_LENGTH = fullPages.children.length - 1
        let that = this
        if (this.fullIndex == 0) {
          return
        } else if (this.fullIndex == FULL_PAGE_LENGTH) {
          window.requestAnimationFrame(function fn() {
            // let number_header = (indexFooter.offsetTop - fullPages.offsetHeight + indexFooter.offsetHeight)/FONT_SIZE
            // let number_header = indexFooter.offsetTop/FONT_SIZE + indexFooter.offsetHeight/FONT_SIZE
            let number_header = (that.fullIndex + (indexFooter.offsetHeight / fullPages.offsetHeight)) * 100 + 4
            that.fullIndex -= 1
            fullPages.setAttribute('style', 'transform: translate3d(0px,' + number_header + 'rem, 0px);touch-action: none;transition: transform 700ms ease 0s;');
          })
        } else {
          window.requestAnimationFrame(function fn() {
            that.fullIndex += 1
            let number_header = that.fullIndex * 100
            fullPages.setAttribute('style', 'transform: translate3d(0px,' + number_header + '%, 0px);touch-action: none;transition: transform 700ms ease 0s;');
          })
        }

      },
      // 向下
      scrolldown() {
        let fullPages = this.$refs.fullPage
        let indexFooter = this.$refs.indexFooter
        const FULL_PAGE_LENGTH = fullPages.children.length - 1
        const FONT_SIZE = getComputedStyle(window.document.documentElement)['font-size'].split('px')[0]
        let that = this
        if (Math.abs(this.fullIndex - 1) == FULL_PAGE_LENGTH + 1) {
          return
        } else if (Math.abs(this.fullIndex - 1) == FULL_PAGE_LENGTH) {

          window.requestAnimationFrame(function fn() {
            // let number_header =-indexFooter.offsetTop/FONT_SIZE - indexFooter.offsetHeight/FONT_SIZE
            // let number_header = (-indexFooter.offsetTop + fullPages.offsetHeight - indexFooter.offsetHeight)/FONT_SIZE
            let number_header = (that.fullIndex - (indexFooter.offsetHeight / fullPages.offsetHeight)) * 100 - 5
            that.fullIndex -= 1
            fullPages.setAttribute('style', 'transform: translate3d(0px,' + number_header + '%, 0px);touch-action: none;transition: transform 700ms ease 0s;');

          })
        } else {
          window.requestAnimationFrame(function fn() {
            that.fullIndex -= 1
            let number_header = that.fullIndex * 100
            fullPages.setAttribute('style', 'transform: translate3d(0px,' + number_header + '%, 0px);touch-action: none;transition: transform 700ms ease 0s;');
          })
        }
      },
      async init() {
        // 精品图书 民俗视频 max-width 初始化
        const fontSize = getComputedStyle(window.document.documentElement)['font-size'].split('px')[0]
        if (this.dataList.booksList.length != 0) {
          this.$nextTick(() => {
            let swich = this.$refs.swichs
            if (swich.children.length != 0) {
              for (const key of swich.children) {
                this.childLendth += key.offsetWidth
              }
              const ds = String((swich.children[0].offsetWidth) / fontSize * 5) - 0.2
              this.$refs.posi.style = 'max-width:' + ds + 'rem'
            }
          });
        }
        if (this.dataList.imagesList.length != 0) {
          this.$nextTick(() => {
            let swich = this.$refs.tswichs
            if (swich.children.length != 0) {
              for (const key of swich.children) {
                this.tchildLendth += key.offsetWidth
              }
              // console.log(swich.children[0].offsetWidth *3/fontSize);
              this.$refs.tposi.style = 'max-width:' + swich.children[0].offsetWidth * 3 / fontSize + 'rem'
            }
          });
        }
        if (this.dataList.audioList.length != 0) {
          this.$nextTick(() => {
            let swich = this.$refs.audioswichs
            if (swich.children.length != 0) {
              for (const key of swich.children) {
                this.achildLendth += key.offsetWidth
              }
              this.$refs.audioposi.style = 'max-width:' + swich.children[0].offsetWidth * 3 / fontSize + 'rem'
            }
          });
        }
      },
      imageLeft() {
        const fontSize = getComputedStyle(window.document.documentElement)['font-size'].split('px')[0]
        let posi = this.$refs.posi
        let swich = this.$refs.swichs
        if (posi.offsetWidth > this.childLendth) {

        } else {
          let that = this
          let lse = 0
          if (swich.getBoundingClientRect().left > 0) {
            lse = posi.getBoundingClientRect().left - swich.getBoundingClientRect().left
          } else {
            lse = Math.abs(swich.getBoundingClientRect().left) + posi.getBoundingClientRect().left
          }
          if (lse.toFixed(4) == this.childLendth - posi.offsetWidth) {
            return
          } else {
            if (this.timeout) return
            window.requestAnimationFrame(function fn() {
              that.index -= 1
              const width = (that.index * that.$refs.swichs.children[0].clientWidth) / fontSize
              swich.style.transform = 'translateX(' + width + 'rem)'
              swich.style.transition = 'transform 1s'
              that.timeout = true
              swich.addEventListener("transitionend", () => {
                that.timeout = false
              })
            })
          }
        }
      },
      imageRight() {
        const fontSize = getComputedStyle(window.document.documentElement)['font-size'].split('px')[0]
        let posi = this.$refs.posi
        let swich = this.$refs.swichs
        if (posi.offsetWidth > this.childLendth) {

        } else {
          if (posi.getBoundingClientRect().left == swich.getBoundingClientRect().left) {
            return
          } else {
            let that = this
            if (this.timeout) return
            window.requestAnimationFrame(function fn() {
              that.index += 1
              const width = (that.index * that.$refs.swichs.children[0].clientWidth) / fontSize
              swich.style.transform = 'translateX(' + width + 'rem)'
              swich.style.transition = 'transform 1s'
              that.timeout = true
              swich.addEventListener("transitionend", () => {
                that.timeout = false
              })
            })
          }
        }
      },
      videoLeft() {
        const fontSize = getComputedStyle(window.document.documentElement)['font-size'].split('px')[0]
        let posi = this.$refs.videoposi
        let swich = this.$refs.videoswichs
        if (posi.offsetWidth > this.vchildLendth) {

        } else {
          let that = this
          if (posi.getBoundingClientRect().left - swich.getBoundingClientRect().left == this.vchildLendth - posi.offsetWidth) {
            return
          } else {
            if (this.vtimeout) return
            window.requestAnimationFrame(function fn() {
              that.vindex -= 1
              const width = (that.vindex * swich.children[0].clientWidth) / fontSize
              swich.style.transform = 'translateX(' + width + 'rem)'
              swich.style.transition = 'transform 1s'
              that.vtimeout = true
              swich.addEventListener("transitionend", () => {
                that.vtimeout = false
              })
            })
          }
        }
      },
      videoRight() {
        const fontSize = getComputedStyle(window.document.documentElement)['font-size'].split('px')[0]
        let posi = this.$refs.videoposi
        let swich = this.$refs.videoswichs

        if (posi.offsetWidth > this.vchildLendth) {

        } else {
          if (posi.getBoundingClientRect().left == swich.getBoundingClientRect().left) {
            return
          } else {
            let that = this
            if (this.vtimeout) return
            window.requestAnimationFrame(function fn() {
              that.vindex += 1
              const width = (that.index * swich.children[0].clientWidth) / fontSize
              swich.style.transform = 'translateX(' + width + 'rem)'
              swich.style.transition = 'transform 1s'
              that.vtimeout = true
              swich.addEventListener("transitionend", () => {
                that.vtimeout = false
              })
            })
          }
        }
      },
      timageLeft() {
        const fontSize = getComputedStyle(window.document.documentElement)['font-size'].split('px')[0]
        let posi = this.$refs.tposi
        let swich = this.$refs.tswichs
        if (posi.offsetWidth > this.tchildLendth) {

        } else {
          let that = this
          let lse = 0
          if (swich.getBoundingClientRect().left > 0) {
            lse = posi.getBoundingClientRect().left - swich.getBoundingClientRect().left
          } else {
            lse = Math.abs(swich.getBoundingClientRect().left) + posi.getBoundingClientRect().left
          }
          if (lse.toFixed(4) == this.tchildLendth - posi.offsetWidth) {
            return
          } else {
            if (this.ttimeout) return
            window.requestAnimationFrame(function fn() {
              that.tindex -= 1
              const width = (that.tindex * swich.children[0].clientWidth) / fontSize
              swich.style.transform = 'translateX(' + width + 'rem)'
              swich.style.transition = 'transform 1s'
              that.ttimeout = true
              swich.addEventListener("transitionend", () => {
                that.ttimeout = false
              })
            })
          }
        }
      },
      timageRight() {
        const fontSize = getComputedStyle(window.document.documentElement)['font-size'].split('px')[0]
        let posi = this.$refs.tposi
        let swich = this.$refs.tswichs
        if (posi.offsetWidth > this.tchildLendth) {

        } else {
          if (posi.getBoundingClientRect().left == swich.getBoundingClientRect().left) {
            return
          } else {
            let that = this
            if (this.ttimeout) return
            window.requestAnimationFrame(function fn() {
              that.tindex += 1
              const width = (that.tindex * swich.children[0].clientWidth) / fontSize
              swich.style.transform = 'translateX(' + width + 'rem)'
              swich.style.transition = 'transform 1s'
              that.ttimeout = true
              swich.addEventListener("transitionend", () => {
                that.ttimeout = false
              })
            })
          }
        }
      },
      audioLeft() {
        const fontSize = getComputedStyle(window.document.documentElement)['font-size'].split('px')[0]
        let posi = this.$refs.audioposi
        let swich = this.$refs.audioswichs
        if (posi.offsetWidth > this.achildLendth) {

        } else {
          let that = this
          let lse = 0
          if (swich.getBoundingClientRect().left > 0) {
            lse = posi.getBoundingClientRect().left - swich.getBoundingClientRect().left
          } else {
            lse = Math.abs(swich.getBoundingClientRect().left) + posi.getBoundingClientRect().left
          }
          if (lse.toFixed(4) == this.achildLendth - posi.offsetWidth) {
            return
          } else {
            if (this.atimeout) return
            window.requestAnimationFrame(function fn() {
              that.aindex -= 1
              const width = (that.aindex * swich.children[0].clientWidth) / fontSize
              swich.style.transform = 'translateX(' + width + 'rem)'
              swich.style.transition = 'transform 1s'
              that.atimeout = true
              swich.addEventListener("transitionend", () => {
                that.atimeout = false
              })
            })
          }
        }
      },
      audioRight() {
        const fontSize = getComputedStyle(window.document.documentElement)['font-size'].split('px')[0]
        let posi = this.$refs.audioposi
        let swich = this.$refs.audioswichs
        if (posi.offsetWidth > this.achildLendth) {

        } else {
          if (posi.getBoundingClientRect().left == swich.getBoundingClientRect().left) {
            return
          } else {
            let that = this
            if (this.atimeout) return
            window.requestAnimationFrame(function fn() {
              that.aindex += 1
              const width = (that.aindex * swich.children[0].clientWidth) / fontSize
              swich.style.transform = 'translateX(' + width + 'rem)'
              swich.style.transition = 'transform 1s'
              that.atimeout = true
              swich.addEventListener("transitionend", () => {
                that.atimeout = false
              })
            })
          }
        }
      },
      getData() {
        listRecommendColumn({
          typeId: this.$store.state.typeId
        }).then(res => {
        })
      },
      // 推荐查询
      getBooks(name,limit) {
        return new Promise((reject, provide) => {
          listHomePageRecommend({
            typeId: this.$store.state.typeId,
            column: name,
            limit:limit,
            pageName: !this.$store.state.pages.ref ? '首页': this.$store.state.pages.ref != 'ref99999'? this.$store.state.pages.name : '首页'
          }).then(res => {
            if (res.data.code == 200) {
              reject(res.data.data)
            }else{
              reject([])
            }
          })
        })
      },
      async getInit() {
        let fullPages = this.$refs.fullPage
        this.fullIndex = 0
        fullPages.setAttribute('style', 'transform: translate3d(0px,' + 0 + '%, 0px);touch-action: none;transition: transform 0s ease 0s;');
        let that = this
        const promises = ['古籍底本', '精品图书', '民俗视频', '民俗音频', '民俗图片'].map(function (name) {
          if(name == '民俗视频'){
            return  that.getBooks(name,8)
          }
          return that.getBooks(name,10)
        });
        const [Ancient, booksList, videoList, audioList, imagesList] = await Promise.all(promises)
        this.bookList = JSON.parse(JSON.stringify(Ancient)) //古籍底本赋值
        this.dataList = {
          Ancient: Ancient,
          imagesList: imagesList,
          booksList: booksList,
          videoList: videoList,
          audioList: audioList
        }
        if(this.$store.state.pages.name == '数字图书资源库'){
          this.dataList.videoList = []
        }
        imagesList.forEach(element => {
          this.srcList.push(element.pic.replace('small.jpg', 'large.jpg'))
        });
        this.init()
      },
      setClickBus() {
        if (this.searchValue == '') {
          sessionStorage.removeItem('esParams')
        } else {
          if (this.searchS == '全部') {
            let params = JSON.parse(JSON.stringify(this.selectList))
            let pa = []
            params.map((data) => {
              let obj = {
                searchName: data.englishName,
                searchValue: this.searchValue,
                searchRelation: '0',//检索关系 0 or ；1 and
                searchType: '0',//检索类型 模糊类型：0，精确：1
              }
              pa.push(obj)
            })
            sessionStorage.setItem('esParams', JSON.stringify(pa))
          } else {
            sessionStorage.setItem('esParams', JSON.stringify([{
              searchName: this.searchS,
              searchRelation: "0",
              searchType: "0",
              searchValue: this.searchValue
            }]))
          }
        }
        sessionStorage.removeItem('category')
        this.$router.push({
          path: '/resource/all',
          query: {
            type: this.searchS,
            value: this.searchValue
          }
        })
      },
    },
    watch: {
      '$store.state.pages': {
        handler: function (news, old) {
          this.$nextTick(()=>{
            this.getInit()
          })
          const pages = sessionStorage.getItem('pages')
          if(pages){
            const pagesJson = JSON.parse(pages)
            if(pagesJson.ref == 'ref99999'){
             this.isActive = 'ref99999'
            }else{
              this.isActive = 'ref'+pagesJson.code
            }
          }
        },
        deep: true,
        immediate: true
      }
    },
  };
</script>
<style lang="less" scoped>
  // el-select 本页面fullPage 绑定 鼠标滚轮事件，select下拉框鼠标滚轮冒泡 ，故将此select插入body中 修改样式
  .el-select-dropdown {
    .el-scrollbar {
      .el-select-dropdown__wrap {
        .el-select-dropdown__item {
          color: #333;
        }

        .el-select-dropdown__item.hover, .el-select-dropdown__item.selected {
          color: #b1222b;
        }
      }
    }
  }

  .index {
    width: 100%;
    // min-height: 44.635rem;
    position: relative;
    min-width: 1320px;
    scroll-snap-align: start;
    height: 100%;
    &.zhulao::before {
      filter: hue-rotate(8deg);
    }
    &.ref2796 .index-page1::before,
    &.ref2796 .index-page2::before,
    &.ref2796 .index-page3::before,
    &.ref2796 .index-page4::before{
      filter: hue-rotate(180deg);
    }
    &.ref2797 .index-page1::before,
    &.ref2797 .index-page2::before,
    &.ref2797 .index-page3::before,
    &.ref2797 .index-page4::before {
      filter: hue-rotate(40deg) saturate(80%);
    }
    &.ref2798 .index-page1::before,
    &.ref2798 .index-page2::before,
    &.ref2798 .index-page3::before,
    &.ref2798 .index-page4::before {
      filter: hue-rotate(346deg) saturate(80%);
    }
    &.ref2799 .index-page1::before,
    &.ref2799 .index-page2::before,
    &.ref2799 .index-page3::before,
    &.ref2799 .index-page4::before
    {
      filter: hue-rotate(232deg) saturate(50%);
    }
    .index-page1, .index-page2, .index-page3, .index-page4 {
      position: relative;
      &::before{
        content: '';
        position: absolute;
        height: 100%;
        width: 100%;
        left: 0;
        top: 0;
        background: url('../../assets/image/index/index_bg.png') no-repeat;
        background-size: cover;
      }
      // background: url('../../assets/image/index/index_bg.png') no-repeat;
      // background-size: cover;
      // background-size: auto;
      height: 100%;
      // height: 44.635rem;
    }
    // .index-page1::before{
    //   position: absolute;
    //   top: 0;
    // }
    // .index-page2::before{
    //   position: absolute;
    //   top: 100%;
    // }

    .index-page1 {
      display: flex;
      justify-content: center;

      .index-pisition {
        position: relative;
        top: 1.698rem;
        width: 100%;
        // width: calc(100% - 27.084rem);
        margin: 0 auto;

        .search {
          .search-logo {
            display: flex;
            justify-content: center;

            .el-image {
              width: 19.792rem;
              height: 3.125rem;
            }
          }

          .index-search-inner {
            border-radius: 0.313rem;
            margin-top: 2.344rem;
            display: flex;
            justify-content: center;

            .index-search-item {
              width: 36.458rem;
              height: 2.604rem;

              /deep/ .el-input-group__prepend {
                background-color: #ffffff;
                border: none;

                .el-select {
                  background-color: #ffffff;
                  color: #b1222b;
                  font-size: 1rem;
                  margin: -5px -20px;

                  .el-input {
                    .el-input__inner {
                      width: 7.292rem;
                      height: 1.54rem;
                      border-right: 0.052rem solid #b1222b;
                      text-align: center;
                      line-height: 1.54rem;
                    }

                    .el-input__suffix {
                      display: flex;
                      justify-content: center;
                      align-items: center;

                      .el-input__suffix-inner {
                        .el-select__caret.el-input__icon.el-icon-arrow-up {
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          transform: rotateZ(0);
                        }

                        .el-select__caret.el-input__icon.el-icon-arrow-up::before {
                          content: "";
                          appearance: none; // 去除select默认的下拉图标
                          border-top: 7px solid #b1222b;
                          border-right: 7px solid transparent;
                          border-left: 7px solid transparent;
                          transition: transform .3s;
                          transform: rotateZ(0);
                        }

                        .el-select__caret.el-input__icon.el-icon-arrow-up.is-reverse::before {
                          content: "";
                          appearance: none; // 去除select默认的下拉图标
                          border-top: 7px solid #b1222b;
                          border-right: 7px solid transparent;
                          border-left: 7px solid transparent;
                          transform: rotateZ(180deg);
                        }
                      }
                    }
                  }

                  /deep/ .el-input.is-focus {
                    .el-input__suffix {
                      .el-input__suffix-inner {
                        transform: rotateZ(180deg)
                      }
                    }
                  }

                  .el-select-dropdown.el-popper {
                    .el-select-dropdown__item {
                      color: #333;
                    }

                    .el-select-dropdown__item.hover {
                      color: #b1222b;
                    }

                  }
                }
              }

              /deep/ .el-input__inner {
                width: 29.115rem;
                height: 2.604rem;
                border: none;
              }

              .el-input-group__append {
                .el-button {
                  width: 6.771rem;
                  height: 2.604rem;
                  background-color: #b1222b;
                  border-top-right-radius: 0.313rem;
                  border-bottom-right-radius: 0.313rem;

                  .button-title {
                    display: flex;
                    justify-content: center;

                    .el-image {
                      margin-right: 0.729rem;
                    }

                    font-size: 1.042rem;
                    color: #ffffff;
                  }
                }
              }

            }
          }

        }

        .booklist {
          position: relative;

          .book {
            .book-show {
              display: flex;
              justify-content: center;
              flex-direction: column;
              align-items: center;

              .book-image {
                display: flex;
                position: relative;
                cursor: pointer;

                .image-tile {
                  position: absolute;
                  left: 0.313rem;
                  top: 0.313rem;
                  writing-mode: vertical-rl;
                  background-color: #f7eed9;
                  display: flex;
                  justify-content: center;
                  align-items: center;

                  &.show {
                    display: none;
                  }

                  .image-boder {
                    border: solid 0.104rem #1d293b;
                    font-size: 0.938rem;
                    color: #333333;
                    white-space: normal;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    word-break: break-all;
                  }
                }
              }

              .book-image::before {
                content: '';
                position: absolute;
                bottom: 0;
                left: 60px;
                transform: skewX(-55deg);
                width: 45px;
                height: 36px;
                background-image: linear-gradient(to top, rgba(174, 174, 174, .9), rgba(255, 255, 255, .3));
              }

              .fast-1-title {
                left: 0;
                font-size: 0.938rem;
                color: #333333;
                margin-top: 0.729rem;
              }

              .fast-box {
                z-index: 999;
                visibility: hidden;
                margin-top: 0.417rem;
                padding: 0.633em 0.573rem;
                background-color: rgba(0, 0, 0, 0.4);
                border-radius: 0.417rem;

                .fast-box-title {
                  font-size: 1.042rem;
                  color: #ffffff;
                  border-bottom: 1px solid #ffffff;
                  padding-bottom: 0.781rem;
                  margin-bottom: 0.677rem;
                }

                .fast-box-xiangq {
                  font-size: 1.042rem;
                  color: #ffffff;
                  cursor: pointer;
                }
              }
            }
          }

          .fast-1 {
            position: absolute;
            left: 44.167rem;
            top: calc(4.427rem);

            .book-show {
              .book-image {
                .el-image {
                  width: 3.854rem;
                  height: 5.417rem;
                }

                .image-tile {
                  width: 1.667rem;
                  height: 3.802rem;

                  .image-boder {
                    width: 1.354rem;
                    height: 3.49rem;
                  }
                }

              }

            }

          }

          .fast-2 {
            position: absolute;
            left: 23.073rem;
            top: calc(6.406rem);

            .book-show {
              .book-image {
                .el-image {
                  width: 4.271rem;
                  height: 5.99rem;
                }

                .image-tile {
                  width: 1.667rem;
                  min-height: 3.802rem;
                  max-height: 4.5rem;

                  .image-boder {
                    width: 1.354rem;
                    margin: 0.1rem 0;
                    // height: 3.49rem;
                  }
                }

              }
            }
          }

          .fast-3 {
            position: absolute;
            left: 58.802rem;
            top: calc(6.875rem);

            .book-show {
              .book-image {
                .el-image {
                  width: 4.271rem;
                  height: 5.99rem
                }

                .image-tile {
                  width: 1.667rem;
                  min-height: 3.802rem;
                  max-height: 4.5rem;

                  .image-boder {
                    width: 1.354rem;
                    margin: 0.1rem 0;
                    // height: 3.49rem;
                  }
                }

              }
            }
          }

          .fast-4 {
            position: absolute;
            left: 69.063rem;
            top: calc(6.198rem);

            .book-show {
              .book-image {
                .el-image {
                  width: 3.646rem;
                  height: 5.104rem;
                }

                .image-tile {
                  width: 1.667rem;
                  min-height: 3.802rem;
                  max-height: 4.5rem;

                  .image-boder {
                    width: 1.354rem;
                    margin: 0.1rem 0;
                    // height: 3.49rem;
                  }
                }

              }
            }
          }

          .fast-5 {
            position: absolute;
            left: 13.542rem;
            top: calc(10.469rem);

            .book-show {
              .book-image {
                .el-image {
                  width: 5.573rem;
                  height: 7.813rem;
                }

                .image-tile {
                  width: 1.667rem;
                  min-height: 3.802rem;
                  max-height: 4.5rem;

                  .image-boder {
                    width: 1.354rem;
                    margin: 0.1rem 0;
                    // height: 3.49rem;
                  }
                }

              }
            }
          }

          .fast-6 {
            position: absolute;
            left: 35.573rem;
            top: calc(10.156rem);

            .book-show {
              .book-image {
                .el-image {
                  width: 4.583rem;
                  height: 6.406rem;
                }

                .image-tile {
                  width: 1.667rem;
                  min-height: 3.802rem;
                  max-height: 4.5rem;

                  .image-boder {
                    width: 1.354rem;
                    margin: 0.1rem 0;
                    // height: 3.49rem;
                  }
                }

              }
            }
          }

          .fast-7 {
            position: absolute;
            left: 81.146rem;
            top: calc(9.063rem);

            .book-show {
              .book-image {
                .el-image {
                  width: 5.313rem;
                  height: 7.396rem;
                }

                .image-tile {
                  width: 1.667rem;
                  min-height: 3.802rem;
                  max-height: 4.5rem;

                  .image-boder {
                    width: 1.354rem;
                    margin: 0.1rem 0;
                    // height: 3.49rem;
                  }
                }

              }
            }
          }

          .fast-8 {
            position: absolute;
            left: 25.208rem;
            top: calc(15rem);

            .book-show {
              .book-image {
                .el-image {
                  width: 6.563rem;
                  height: 9.115rem;
                }

                .image-tile {
                  width: 1.667rem;
                  min-height: 3.802rem;
                  max-height: 4.5rem;

                  .image-boder {
                    width: 1.354rem;
                    margin: 0.1rem 0;
                    // height: 3.49rem;
                  }
                }

              }
            }
          }

          .fast-9 {
            position: absolute;
            left: 52.5rem;
            top: calc(15.104rem);

            .book-show {
              .book-image {
                .el-image {
                  width: 7.396rem;
                  height: 10.313rem;
                }

                .image-tile {
                  width: 1.667rem;
                  min-height: 3.802rem;
                  max-height: 4.5rem;

                  .image-boder {
                    width: 1.354rem;
                    margin: 0.1rem 0;
                    // height: 3.49rem;
                  }
                }

              }
            }
          }

          .fast-10 {
            position: absolute;
            left: 68.802rem;
            top: calc(14.375rem);

            .book-show {
              .book-image {
                .el-image {
                  width: 5.677rem;
                  height: 7.917rem;
                }

                .image-tile {
                  width: 1.667rem;
                  min-height: 3.802rem;
                  max-height: 4.5rem;

                  .image-boder {
                    width: 1.354rem;
                    margin: 0.1rem 0;
                    // height: 3.49rem;
                  }
                }

              }
            }
          }

          .fast-1:hover,
          .fast-2:hover,
          .fast-3:hover,
          .fast-4:hover,
          .fast-5:hover,
          .fast-6:hover,
          .fast-7:hover,
          .fast-8:hover,
          .fast-9:hover,
          .fast-10:hover {
            .fast-1-title {
              display: none;
            }

            .book-image::before {
              display: none;
            }

            .fast-box {
              visibility: visible;
            }
          }
        }

        .more {
          cursor: pointer;
          position: absolute;
          bottom: 4rem;
          left: 50%;
          transform: translate(-50%, 0);
          width: 7.917rem;
          height: 1.875rem;
          background: url('../../assets/image/index/more.png') no-repeat;
          background-size: cover;
          font-size: 0.833rem;
          color: #ffffff;
          text-align: center;
          line-height: 1.875rem;
        }
      }

    }

    .index-page2 {
      display: flex;
      justify-content: center;

      .index-pisitions {
        position: relative;
        top: 3.698rem;
        width: 100%;

        .speciabox {
          width: 100%;
          display: flex;
          justify-content: center;

          .special {
            background: url('../../assets/image/index/special.png') no-repeat;
            background-size: contain;
            height: 3.75rem;
            width: calc(17.5rem + 19.472rem);
            margin: 0 auto;
          }
        }

        .special2-box {
          width: calc(100% - 17.188rem - 17.188rem);
          margin: 0 auto;
          display: flex;
          // justify-content: center;
          // flex-wrap: wrap;
          // box-sizing: border-box;
          display: grid;
          grid-template-columns: repeat(auto-fill, 18.958rem);
          justify-content: space-around;

          .special2-for {
            background: url('../../assets/image/index/special2.png') no-repeat;
            background-size: contain;
            width: 18.958rem;
            height: 13.333rem;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            cursor: pointer;

            &:nth-child(3n) {
              margin-right: 0;
            }

            .banner-title {
              font-size: 0.833rem;
              letter-spacing: 0.042rem;
              color: #333333;
              text-align: center;
              width: 90%;
              overflow: hidden;
              text-overflow: ellipsis; //多出部分用...代替
              display: -webkit-box; //定义为盒子模型显示
              -webkit-line-clamp: 1; //用来限制在一个块元素显示的文本的行数
              -webkit-box-orient: vertical; //从上到下垂直排列子元素（设置伸缩盒子的子元素排列方式）
            }

            .el-image {
              width: 13.229rem;
              height: 7.396rem;
              position: relative;

              &::after {
                content: '';
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                background: url('../../assets/image/resource/video_logo.png') no-repeat;
                z-index: 2;
                width: 50px;
                height: 50px;
                opacity: .8;
              }

              &::before {
                content: '';
                position: absolute;
                box-shadow: inset 0 0 300px 100px #000;
                width: 100%;
                height: 100%;
                opacity: .4;
              }
            }

            &:hover {
              .el-image::after {
                opacity: 1;
              }

              .el-image::before {
                opacity: .6;
              }
            }
          }

          @media screen and (max-width: 1200px) {
            .special2-for:nth-child(3n) {
              margin-right: 4.375rem;
            }
          }
        }

        .special-box, .special-box1 {
          .morans {
            position: relative;

            .moran {
              cursor: pointer;
              position: absolute;
              left: 50%;
              bottom: 2.813rem;
              transform: translateX(-50%);
              width: 5.833rem;
              height: 1.563rem;
              border-radius: 0.208rem;
              border: solid 0.052rem #82642a;
              display: flex;
              align-items: center;
              justify-content: center;

              .el-image {
                display: flex;
                align-items: center;
                margin-left: 2px;
              }
            }
          }

        }

        .special-box {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          width: calc(46.667rem + 18.985rem);
          margin: 0 auto;
          margin-top: 1.927rem;

          .special-box-item {
            background: url('../../assets/image/index/image1.png') no-repeat;
            background-size: cover;
            width: 18.958rem;
            height: 13.333rem;
          }

          .special-box-item1 {
            background: url('../../assets/image/index/image2.png') no-repeat;
            background-size: cover;
            width: 18.958rem;
            height: 13.333rem;
          }

          .special-box-item2 {
            background: url('../../assets/image/index/image3.png') no-repeat;
            background-size: cover;
            width: 18.958rem;
            height: 13.333rem;
          }
        }

        .special-box1 {
          display: flex;
          justify-content: center;
          flex-wrap: wrap;
          margin-top: 1.667rem;

          .special-box-item3 {
            background: url('../../assets/image/index/image4.png') no-repeat;
            background-size: cover;
            width: 18.958rem;
            height: 13.333rem;
          }

          .special-box-item4 {
            background: url('../../assets/image/index/image5.png') no-repeat;
            background-size: cover;
            width: 18.958rem;
            height: 13.333rem;
          }
        }

        .more {
          position: absolute;
          bottom: 6rem;
          left: 50%;
          transform: translate(-50%, 0);
          width: 7.917rem;
          height: 1.875rem;
          background: url('../../assets/image/index/more.png') no-repeat;
          background-size: cover;
          font-size: 0.833rem;
          color: #ffffff;
          text-align: center;
          line-height: 1.875rem;
        }
      }
    }

    .index-page3 {
      display: flex;
      flex-direction: column;

      .index-pisition3 {
        position: relative;
        top: 2.354rem;
        width: 100%;
        height: calc(100% - 6.354rem);

        .speciabox {
          width: 100%;
          display: flex;
          justify-content: center;

          .special {
            background: url('../../assets/image/index/boutbook1.png') no-repeat;
            background-size: contain;
            height: 2.522rem;
            width: calc(11.5rem + 19.472rem);
            margin: 0 auto;
          }
        }

        .swich {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 6.302rem;

          .swich-left, .swich-right {
            .el-image {
              width: 1.25rem;
              height: 2.604rem;
            }
          }

          .swich-left {
            cursor: pointer;
            margin-right: 2.917rem;
          }

          .swich-right {
            cursor: pointer;
            // margin-left: 2.917rem;
          }

          .index-swich-posi {
            // max-width:  50.875rem;
            box-sizing: content-box;
            min-width: 7.24rem;
            position: relative;
            overflow-x: hidden;

            .swich-banners {
              display: flex;

              .banner-item {
                box-sizing: border-box;
                width: calc(9.479rem + 2.448rem);
                padding-right: 2.448rem;

                .el-image {
                  width: 9.479rem;
                  height: 12.969rem;
                }

                .banner-title, .banner-yizu {
                  font-size: 0.833rem;
                  letter-spacing: 0.042rem;
                  color: #333333;
                  text-align: center;
                  width: 90%;
                  max-width: 13.34rem;
                  overflow: hidden;
                  text-overflow: ellipsis; //多出部分用...代替
                  display: -webkit-box; //定义为盒子模型显示
                  -webkit-line-clamp: 1; //用来限制在一个块元素显示的文本的行数
                  -webkit-box-orient: vertical; //从上到下垂直排列子元素（设置伸缩盒子的子元素排列方式）
                }
              }
            }

          }

          .index-swich-posi.swich-video {
            height: auto;

            .swich-banners {
              .banner-item {
                cursor: pointer;
                .el-image {
                  width: 9.479rem;
                  height: 12.969rem;
                }
              }
            }
          }

        }

        .more-center {
          // display: flex;
          // justify-content: center;
          // margin-top: 1.875rem;
          // margin-bottom: 3.125rem;
          // position: absolute;
          // bottom: 0;
          .more {
            position: absolute;
            bottom: 1rem;
            left: 50%;
            transform: translate(-50%, 0);
            width: 7.917rem;
            height: 1.875rem;
            background: url('../../assets/image/index/more.png') no-repeat;
            background-size: cover;
            font-size: 0.833rem;
            color: #ffffff;
            text-align: center;
            line-height: 1.875rem;
          }
        }

        .speciabox {
          width: 100%;
          display: flex;
          justify-content: center;

          .special2 {
            background: url('../../assets/image/index/custom_video.png') no-repeat;
            background-size: contain;
            height: 2.522rem;
            width: calc(11.5rem + 19.472rem);
          }
        }

      }
    }

    .index-page4 {
      display: flex;
      flex-direction: column;

      .index-pisition3 {
        position: relative;
        top: 1.292rem;
        width: 100%;

        .speciabox {
          width: 100%;
          display: flex;
          justify-content: center;

          .special {
            background: url('../../assets/image/index/images1.png') no-repeat;
            background-size: contain;
            height: 2.522rem;
            width: calc(11.5rem + 19.472rem);
            margin: 0 auto;
          }
        }

        .swich {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 2.135rem;

          .swich-left, .swich-right {
            .el-image {
              width: 1.25rem;
              height: 2.604rem;
            }
          }

          .swich-left {
            cursor: pointer;
            margin-right: 2.917rem;
          }

          .swich-right {
            margin-left: calc(2.917rem - 1.502rem);
            cursor: pointer;
          }

          .index-swich-posi {
            // max-width:  50.875rem;
            min-width: 7.24rem;
            position: relative;
            overflow-x: hidden;
            z-index: 999;

            .swich-banners {
              display: flex;

              .banner-item {
                padding-right: 1.302rem;

                .el-image {
                  width: 13.34rem;
                  height: 8.802rem;
                }

                .banner-title, .banner-yizu {
                  font-size: 0.833rem;
                  letter-spacing: 0.042rem;
                  color: #333333;
                  text-align: center;
                  width: 90%;
                  max-width: 13.34rem;
                  overflow: hidden;
                  text-overflow: ellipsis; //多出部分用...代替
                  display: -webkit-box; //定义为盒子模型显示
                  -webkit-line-clamp: 1; //用来限制在一个块元素显示的文本的行数
                  -webkit-box-orient: vertical; //从上到下垂直排列子元素（设置伸缩盒子的子元素排列方式）
                }
              }
            }

          }

          .index-swich-posi.swich-video {
            height: auto;

            .swich-banners {
              .banner-item {
                cursor: pointer;
                .el-image {
                  width: 13.34rem;
                  height: 8.802rem;
                }
              }
            }
          }

        }

        .more-center {
          display: flex;
          justify-content: center;
          margin-top: 1.875rem;
          margin-bottom: 1.125rem;

          .more {
            display: flex;
            justify-content: center;
            width: 7.917rem;
            height: 1.875rem;
            background: url('../../assets/image/index/more.png') no-repeat;
            background-size: cover;
            font-size: 0.833rem;
            color: #ffffff;
            text-align: center;
            line-height: 1.875rem;
          }
        }

        .speciabox {
          width: 100%;
          display: flex;
          justify-content: center;

          .special2 {
            background: url('../../assets/image/index/audio1.png') no-repeat;
            background-size: contain;
            height: 2.522rem;
            width: calc(11.5rem + 19.472rem);
          }
        }

      }
    }

    .index-footer {
      .footer {
        width: 100%;
        min-height: 15.625rem;
        min-width: 1300px;
      }
    }
  }
</style>
